<div class="popup" *ngIf="isVisibleDetails">
    <div class="container-detalles panelDetailLocations" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches && !isLoading)}">
      <loading [isLoading]="isLoading"></loading>
  
      <div *ngIf="!mobileQuery.matches" class="btnClose">
        <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false" aria-label="Example home icon" fontIcon="cancel" (click)="CancelButton()"></mat-icon>
      </div>

      <div *ngIf="!mobileQuery.matches" class="arrow-container">
        <mat-icon *ngIf="!fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_up</mat-icon>
        <mat-icon *ngIf="fullScreen" (click)="fullScreen = !fullScreen" class="mobile-flecha">keyboard_arrow_down</mat-icon>
      </div>
      <div class="details-flex">
  
        <!-- Primera sección -->
        <div class="header_panel">

          <div  *ngIf="(panelDetalilService.canClosePanel$ | async)" class="btnReturn" (click)="CancelButton()" matTooltip="Regresar">
            <mat-icon>arrow_back_ios</mat-icon>
          </div>
  
            <!-- Encabezado -->
            <div *ngIf="images.length == 0" class="header-background" [ngClass]="{'col-3': !mobileQuery.matches}">
                <img [src]="locationDTO.panelIcon | findUrl" class="header-img" />

                <!-- VIN-->
                <div class="row header-text" [ngClass]="{'col-9': !mobileQuery.matches}">
                    <label class="subtitlePanel" [matTooltip]="this.locationDTO.description"> {{this.locationDTO.description | slice:0:20}}</label>

                    <label class="vin-title-container"> 
                      <div class="vin-title">
                        {{ this.locationDTO.identifier | slice:0:45 }}
                      </div>
                    </label>
                    
                </div>

                <div class="tool-opener" *ngIf="mobileQuery.matches || fullScreen" (click)="toggleToolButton()">
                  <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
                  <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
                </div>
            </div>

            <!-- carrusel -->
            <div *ngIf="images.length > 0 && mobileQuery.matches" class="header-carousel" [ngClass]="{'col-3': !mobileQuery.matches}">
              <carousel [images]="images"></carousel>
            </div>

        </div>

        <!-- seccion de herramientas -->
        <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical details-tool-list-for-tutorial">
              <location-button-toolbar *ngIf="!isLoading" 
                [identifier]="locationDTO.identifier"
                [description]="locationDTO.description" 
                [isDetailLocations]="true"
                [isLoadingParent]="isLoading"
                [isMonitor]="mobileQuery.matches"
                [images]="images"
                [isReloadable]="true"
                [CordX]="locationDTO.cordsX"
                [CordY]="locationDTO.cordsY"
                [isVerticalList]="true">
              </location-button-toolbar>
              
              <app-report-list [identifier]="locationDTO.identifier"
              [description]="locationDTO.description" 
              [isDetailLocations]="true"
              [isVerticalList]="true"></app-report-list>
        </div>
        <!-- seccion de ttabs -->
        <div class="tab-group">
          <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="selectTab($event)" class="details-tab-group full-width-tabs" [dynamicHeight]="true">
            <mat-tab>
              <ng-template mat-tab-label >
                <label  matTooltip="Resumen del Activo" matTooltipPosition="above">
                  Detalle </label>
              </ng-template>
              <ng-template matTabContent >
                <div class="tab-content-wrapper">
                    <!-- primera sección -->
                    <div class="main-data-section-container">

                      <div class="row-image-data">
                        <div class="title-img-container">
                          <!-- <label class="titlePanel">Dirección</label> -->
                          <img class="title-img" [src]="(EnumDetailIconNames.ingenieros | detailsIcons:EnumEngineerDetailProperties.Direccion:EnumEngineerDetailProperties.Valor_unico) | findUrl">
                        </div>
                        <div class="">
                          <div class="general-data">{{ Values[Keys.indexOf('CurrentLocation')] || this.Address }}</div>
                        </div>
                      </div>
                      
                        <div class="image-data">
                          <div class="title-img-container" matTooltip="Estado de Actualización" matTooltipPosition="above">
                            <!-- <label class="titlePanel">Estado de Actualización:</label> -->
                            <img class="title-img" [src]="(EnumDetailIconNames.ingenieros | detailsIcons:EnumEngineerDetailProperties.EstadoActualizacion:locationDTO.categoryStatus) | findUrl">
                          </div>
                          <div class="">
                            <div class="general-data">{{ this.locationDTO.categoryStatus || 'N/A' }}</div>
                          </div>
                        </div>

                        <div class="image-data">
                          <div class="title-img-container" matTooltip="Última Actualización" matTooltipPosition="above">
                            <!-- <label class="titlePanel">Ult. Act:</label> -->
                            <img class="title-img" [src]="(EnumDetailIconNames.ingenieros | detailsIcons:EnumEngineerDetailProperties.UltimaActualizacion:EnumEngineerDetailProperties.Valor_unico) | findUrl">
                          </div>
                          <div class="general-data">
                            <span > {{ this.locationDTO.lastUpdate || 'N/A' }}</span>
                          </div>
                        </div>
                        
                        <div class="image-data">
                          <div class="title-img-container" matTooltip="Coordenadas" matTooltipPosition="above">
                            <!-- <label class="titlePanel">Coordenadas</label> -->
                            <img class="title-img" [src]="(EnumDetailIconNames.ingenieros | detailsIcons:EnumEngineerDetailProperties.Coordenadas:EnumEngineerDetailProperties.Valor_unico) | findUrl">
                          </div>
                          <div class="">
                            <div class="general-data">{{ this.Coords || 'N/A' }}</div>
                          </div>
                        </div>

                        <div class="image-data" *ngIf="!!this.locationDTO.subGroup" matTooltip="Subcuenta">
                          <div class="title-img-container">
                            <!-- <label class="titlePanel">Subcuenta</label> -->
                            <img class="title-img" [src]="(EnumDetailIconNames.ingenieros | detailsIcons:EnumEngineerDetailProperties.Subcuenta:EnumEngineerDetailProperties.Valor_unico) | findUrl">
                          </div>
                          <div class="">
                            <div class="general-data">{{ this.locationDTO.subGroup.name || 'N/A' }}</div>
                          </div>
                        </div>
                      
                    </div>
                      
      
                    <!-- Segunda sección datos del activo-->
                    <div class="data-section-container">
                      <div class="text-header">
                        <h3>Datos del Activo</h3>
                      </div>
      
                      <div *ngFor="let key of detallesActivo; let i = index" >
                        <div *ngIf="getNameVisibility(key) && key !== 'ZoneId' && key !== 'RegionId'" class="row-data">
                          <div class="">
                            <label class="titlePanel">{{ getUsableName(key) }}</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ Values[Keys.indexOf(key)] || 'N/A' }}</div>
                          </div>
                        </div>
                      </div>
      
                    </div>
      
                    <!-- Vuarta sección -->
                    <div class="data-section-container" *ngIf="detallesGPS.length > 0">
                      <div class="text-header">
                        <h3>Datos del GPS</h3>
                      </div>
              
                      <div *ngIf="getNameVisibility('StatusGPS')" class="row-data">
                        <div class="">
                          <label class="titlePanel">{{ getUsableName('Estado del GPS') }}</label>
                        </div>
                        <div class="">
                          <div class="general-data">{{ locationDTO.gpsStatus || 'N/A' }}</div>
                        </div>
                      </div>
              
                      <div *ngFor="let key of detallesGPS; let i = index" >
                        <div *ngIf="getNameVisibility(key)" class="row-data">
                          <div class="">
                            <label class="titlePanel">{{ getUsableName(key) }}</label>
                          </div>
                          <div class="">
                            <div class="general-data">{{ Values[Keys.indexOf(key)] || 'N/A' }}</div>
                          </div>
                        </div>
                      </div>
      
      
                    </div>
                </div>
              </ng-template>
            </mat-tab>
  
  
             <!-- segundo tab servicios asociados -->
  
             <!-- <mat-tab *ngIf="hasRelatedData && isBranding" [disabled]="this.isLoading">
              <ng-template mat-tab-label >
                <label  matTooltip="Activos Asociados" matTooltipPosition="above">
                  Tickets 
                </label>
              </ng-template>
              <ng-template matTabContent >
                <div class="tab-content-wrapper">
                  <div [ngClass]="{'container': mobileQuery.matches}">
                    primera seccion servicios asociados
                    <location-related-list [includeRoute]="true" [identifier]="this.locationDTO.identifier" *ngIf="this.selectedTabIndex == 1"></location-related-list>
                  </div>
                </div>
                  
              </ng-template>
            </mat-tab> -->

            <ng-container *ngIf="isRouteSeetAllowed">
              <div *ngFor="let routeSheet of routeSheets; let i = index">
                <mat-tab  class="categoryTabLabel">
                  <ng-template mat-tab-label>
                    <!-- <img [src]="routeSheet.category.icon | findUrl" width="30px" class="mr-5">  -->
                    <label matTooltipPosition="above">
                      {{ routeSheet.total }} {{routeSheet.routeSheetName }}
                    </label>
                  </ng-template>

                  <ng-template matTabContent>
                    <div class="tab-content-wrapper">
                      <div [ngClass]="{'container': mobileQuery.matches}">
                        <!-- asociados  -->
                        <app-route-sheet [identifier]="this.locationDTO.identifier"
                                                                          [childCategory]="routeSheet.routeSheetIdLocationCategory"
                                                                          [parentCategory]="this.locationDTO.idLocationCategory"
                                                                          [parentCoordX]="this.locationDTO.cordsX"
                                                                          [parentCoordY]="this.locationDTO.cordsY"
                                                                          (categoryTotal)="loadTotal($event, routeSheet)">
                        </app-route-sheet>
                      </div>
                    </div>
                  </ng-template>
                </mat-tab>
              </div>             
            </ng-container>
            
            
  

          </mat-tab-group>
        </div>
      </div>  
  
    </div>
  </div>